export default "__VITE_ASSET__CyzTG0YN__"